<template>
  <v-dialog v-model="showModal" max-width="500px">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon :color="revenda.ligacao_habilitada ? 'error' : 'success'" class="mr-2">
          {{ revenda.ligacao_habilitada ? 'mdi-phone-off' : 'mdi-phone' }}
        </v-icon>
        <span>{{ revenda.ligacao_habilitada ? 'Desabilitar' : 'Habilitar' }} Recebimento de Ligações</span>
      </v-card-title>

      <v-card-text>
        <p class="text-body-1 mb-4">
          Você tem certeza que deseja 
          <strong>{{ revenda.ligacao_habilitada ? 'desativar' : 'ativar' }}</strong> 
          o recebimento de ligações para a revenda 
          <strong>{{ revenda.nomefantasia }}</strong>?
        </p>

        <v-alert 
          :type="revenda.ligacao_habilitada ? 'warning' : 'info'" 
          variant="tonal" 
          class="mb-0"
        >
          <template v-if="revenda.ligacao_habilitada">
            A revenda não receberá mais ligações automáticas do sistema.
          </template>
          <template v-else>
            A revenda voltará a receber ligações automáticas do sistema.
          </template>
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        
        <v-btn
          variant="text"
          @click="cancelar"
          :disabled="loading"
        >
          Cancelar
        </v-btn>
        
        <v-btn
          :color="revenda.ligacao_habilitada ? 'error' : 'success'"
          @click="confirmar"
          :loading="loading"
          variant="elevated"
        >
          {{ revenda.ligacao_habilitada ? 'Desabilitar' : 'Habilitar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRevendaStore } from '@/stores/revenda';
import { useNotificationStore } from '@/stores/notification';

// Props
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  revenda: {
    type: Object,
    required: true
  }
});

// Emits
const emit = defineEmits(['update:show', 'updated', 'loading-state']);

// Stores
const revendaStore = useRevendaStore();
const notificationStore = useNotificationStore();

// Local state
const loading = ref(false);

// Computed
const showModal = computed({
  get: () => props.show,
  set: (value) => emit('update:show', value)
});

// Methods
const cancelar = () => {
  showModal.value = false;
};

const confirmar = async () => {
  loading.value = true;
  emit('loading-state', { revendaId: props.revenda.id, loading: true });
  
  try {
    const response = await revendaStore.processarStatusLigacaoRevenda(props.revenda.id);
    
    if (response.success) {
      notificationStore.showNotification(
        response.message,
        'success'
      );
      
      // Emit the updated revenda
      emit('updated', {
        ...props.revenda,
        ligacao_habilitada: !props.revenda.ligacao_habilitada
      });
      
      showModal.value = false;
    } else {
      notificationStore.showNotification(
        response.message || 'Erro ao atualizar status de ligação',
        'error'
      );
    }
  } catch (error) {
    console.error('Erro ao alterar status de ligação:', error);
    notificationStore.showNotification(
      'Erro ao processar solicitação',
      'error'
    );
  } finally {
    loading.value = false;
    emit('loading-state', { revendaId: props.revenda.id, loading: false });
  }
};
</script>
